<div style="padding: 0;">
    <app-grid [columns]="columns" 
              [settings]="settings"
              [rows]="rows"
              [parentControlledFields]="parentControlledFields"
              (eventEmission)="onEventEmission($event)">
    </app-grid>
</div>
<!-- <app-image-cropper [src]="imgUrl"
                   (confirm)="confirm($event)"></app-image-cropper> -->